/**
 * Application roles.
 *
 * These are DELIBERATELY decoupled from Discord role IDs. Discord role IDs are
 * mapped onto these application roles at runtime through the configurable role
 * mapping (see the `role_mappings` table + `DISCORD_ROLE_MAP` env bootstrap).
 * Never reference a raw Discord role ID outside the Discord integration layer.
 */
export const APP_ROLES = [
    'NONE',
    'DEPARTMENT_LEAD',
    'DEVELOPER',
    'SENIOR_DEVELOPER',
    'DIRECTOR',
];
export const APP_ROLE_META = {
    NONE: {
        key: 'NONE',
        label: 'No Access',
        shortLabel: 'None',
        description: 'Authenticated through Discord but holding no mapped role. Cannot access the platform.',
        rank: 0,
        tone: 'muted',
    },
    DEPARTMENT_LEAD: {
        key: 'DEPARTMENT_LEAD',
        label: 'Department Leadership',
        shortLabel: 'Leadership',
        description: 'Opens and tracks Leadership Requests on behalf of a department. No access to development tasks, analytics or administration.',
        rank: 5,
        tone: 'info',
    },
    DEVELOPER: {
        key: 'DEVELOPER',
        label: 'Development Team Member',
        shortLabel: 'Developer',
        description: 'Creates and delivers development tasks. Owns the tasks assigned to them.',
        rank: 10,
        tone: 'neutral',
    },
    SENIOR_DEVELOPER: {
        key: 'SENIOR_DEVELOPER',
        label: 'Senior Developer',
        shortLabel: 'Senior',
        description: 'Broader visibility across development activity. May assist with and reassign tasks where authorised.',
        rank: 20,
        tone: 'info',
    },
    DIRECTOR: {
        key: 'DIRECTOR',
        label: 'Development Director',
        shortLabel: 'Director',
        description: 'Full oversight. Assigns work, performs final review sign-off, manages developers and platform configuration.',
        rank: 30,
        tone: 'accent',
    },
};
/** Roles a director may assign to a user through Developer Management. */
export const ASSIGNABLE_ROLES = [
    'NONE',
    'DEPARTMENT_LEAD',
    'DEVELOPER',
    'SENIOR_DEVELOPER',
    'DIRECTOR',
];
/** The developer-track roles — everyone who can hold and work a task. */
export const DEVELOPMENT_ROLES = ['DEVELOPER', 'SENIOR_DEVELOPER', 'DIRECTOR'];
export function isAppRole(value) {
    return typeof value === 'string' && APP_ROLES.includes(value);
}
/** Returns the highest-ranked role from a set of mapped roles, or `NONE`. */
export function highestRole(roles) {
    let winner = 'NONE';
    for (const role of roles) {
        if (APP_ROLE_META[role].rank > APP_ROLE_META[winner].rank)
            winner = role;
    }
    return winner;
}
//# sourceMappingURL=roles.js.map